<template>
    <!-- <Transition :name="isDesktop.screenSize.value == 'xs' ? 'modalslide' : 'fade'"> -->
    <app-modal :size="size" :grid="true" v-if="hasRole(modalShowVal)">
        <app-modal-content>
            <AppModalHeader
                :headingText="'Email: Hi there'"
                :classes="''"
                @onHeaderToggle="toggleModal"
            >
            </AppModalHeader>
            <AppModalBody classes="bg-white dark:!bg-black-500 pb-6">
                <div class="0email-metadata">
                    <h4 class="text-sm font-medium text-gray-500"><strong>From:</strong> ricardo.c@foxtons.estateagents.com</h4>
                </div>
            </AppModalBody>
            <!-- <app-modal-footer
                variant="secondary"
                @onHideModal="toggleModal"
                saveBtnText="Save"
                @onSubmit="toggleModal"
            >
            </app-modal-footer> -->
        </app-modal-content>
    </app-modal>
    <!-- </Transition> -->
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import AppModal from '@/components/appComponents/modal/AppModal.vue';
import AppModalBody from '@/components/appComponents/modal/AppModalBody.vue';
import AppModalContent from '@/components/appComponents/modal/AppModalContent.vue';
import AppModalFooter from '@/components/appComponents/modal/AppModalFooter.vue';
import AppModalHeader from '@/components/appComponents/modal/AppModalHeader.vue'; // Fixed import here
import useToggleModal from '@/composables/useToggleModal';
import { useScreenSize } from '@/composables/globals';

const props = defineProps({
    modalShowVal: {
        type: String,
        default: '',
        required: true,
    },
    size: {
        type: String,
        default: 'large',
    },
});

const isDesktop = useScreenSize();
const { openModal, hasRole, toggleModal } = useToggleModal();
const emit = defineEmits(['onHideModal']);

// Show modal logic
const showModal = (modalShowVal) => {
    console.log(modalShowVal, 'checking modal modalShowVal');
    openModal(modalShowVal); // directly call openModal
};

defineExpose({
    showModal,
});
</script>

<style scoped>
</style>
